
import React, { useState } from "react";
import { useEffect } from "react";
import LeftSidePopup from "../../../UI/LeftSidePopup";
import MenuBtns from "../../../UI/MenuBtns";
import classes from './EditCourseMenu.module.css';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BackArrowMenu from "../../../UI/BackArrowMenu";
import ScrollLTR from "../../../lms-shared/UI/ScrollLTR";
import * as PathRouter from '../../../../models/PathRoute'

const EditCourseMenu = ({ children, currentIndex = 0, studyGroup }) => {
    const [currentContentIndexState, setCurrentContentIndexState] = useState(currentIndex)
    const texts = useSelector(state => state.translate.texts);
    const { homeUrl } = useSelector(state => state.application);

    const navigate = useNavigate()

    useEffect(() => {
        setCurrentContentIndexState(currentIndex)
    }, [currentIndex])

    const goTo = () => {
        navigate(`${homeUrl}/${PathRouter.COURSES}`)
    }

    return (
        <>
            <div className={classes.EditCourseMenu}>

                <LeftSidePopup>
                    <BackArrowMenu title={texts.toMyCourses} onClick={goTo} select={true} />
                    <MenuBtns setCurrentContentIndexState={setCurrentContentIndexState} currentContentIndexState={currentContentIndexState}>{children}</MenuBtns>
                </LeftSidePopup>

                <div className={classes.ActionCardContainer}>
                    <ScrollLTR dropStyle={{ height: "100%" }}>
                        {children[currentContentIndexState].props.children}
                    </ScrollLTR>
                </div>

            </div>
        </>
    )
}


export default EditCourseMenu;